import React, { useMemo } from "react";
import { Select } from "components";
import { useTranslate } from "hooks";
import { unitOptions } from "variables";
import { useProductUnit } from "stores/product";

export const UnitsDropDown = () => {
  const translate = useTranslate();
  const unit = useProductUnit();
  const unitOptionsList = useMemo(
    () =>
      unitOptions.map(({ value, label }) => ({
        value,
        label: translate(`PROJECT_UNITS_${label.toUpperCase()}`),
      })),
    [translate],
  );
  return (
    <div className="mt-1 ms-xl-auto">
      <Select
        options={unitOptionsList}
        data-recording-disable={true}
        value={unitOptionsList.find((item) => item.value === unit)}
        name="units"
        aria-label={translate.stringOnly("PROJECT_UNITS_WITH_ASTERISK")}
        // Todo: implement onChange to change units system.
        onChange={() => {}}
        disabled={true}
      />
    </div>
  );
};
